export default "__VITE_ASSET__DyqoxbI$__"